module.exports = __webpack_public_path__ + "img/Flag_of_Vietnam.cc2e55f0.svg";